import { FC } from "react";
import S from "./index.module.scss";

interface ITwoColumnsBlock {
  title: string;
  subtitle: string;
}

const TwoColumnsBlock: FC<ITwoColumnsBlock> = ({ title, subtitle }) => {
  return (
    <div className={S.wrapper}>
      <h2 className={S.slogan}>{title}</h2>
      <h3 className={S.subtitle} dangerouslySetInnerHTML={{ __html: subtitle }} />
    </div>
  );
};

export default TwoColumnsBlock;
